<div id="landing-av-index" class="fadein">
    <app-landing-header [landingPage]="'index'"></app-landing-header>
    <div class="bg-primary-900 primary-50 margin-fixed">
        <div class="banner-audiovisual d-flex align-items-lg-center pt-5 pt-lg-0">
            <div class="container">
                <div class="row h-100">
                    <div class="col-12 h-100 d-flex flex-column d-lg-block">
                        <div class="col-8 col-sm-6">
                            <p class="p-display secondary-creative-500">
                                <strong class="p-display-bold">SEGO Creative</strong>
                            </p>
                            <h1 class="h1-display">Invertimos en cultura</h1>
                            <p class="p-display">Nos mueve la pasión por impulsar todo el talento de las
                                industrias culturales y creativas.</p>
                        </div>
                        <div class="call-to-action pt-lg-3 mt-auto mb-4 mb-lg-0">
                            <a routerLink="/creative/registro"
                                class="btn btn-secondary btn-financiacion w-100 w-lg-auto"
                                title="Registra tu proyecto">Registra tu proyecto</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container py-4 py-lg-5">
            <div class="row align-items-center py-4 py-lg-3">
                <div class="col-lg-6">
                    <div
                        class="img-container-proyectos border-2 border-radius-20 border-secondary-creative-500 mx-auto mx-lg-0">
                        <img src="assets/images/creative/landing/audiovisual_proyectos.jpg"
                            class="img-fluid border-radius-20" title="SEGO Creative" alt="SEGO Creative">
                    </div>
                </div>
                <div class="col-lg-6 text-center px-lg-4">
                    <h2 class="h2-semibold mt-4 mt-lg-0 mb-2">VARIEDAD DE PROYECTOS</h2>
                    <p class="p1-regular mb-0">Nuestro equipo de expertos analizará en profundidad todos los
                        proyectos del sector audiovisual, tanto de ficción como de animación y documental, para
                        seleccionar aquéllos con mayor potencial y atractivo para los inversores.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-primary-800 primary-50 py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h2 class="h2-semibold mb-4 mb-lg-5">NUESTRAS VENTAJAS</h2>
                </div>

                <div id="swiper-landing-creative" class="col-12 pe-0">
                    <div class="swiper swiperVentajasCreative">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="mat-icon-container">
                                    <span class="mat-icon-size-30 material-symbols-outlined">emoji_events</span>
                                </div>
                                <div class="border-bottom-2 border-secondary-creative-500 border-ventaja mt-1 mb-3">
                                </div>
                                <p class="p1-semibold">EXPERIENCIA</p>
                                <p class="p2-regular">Nuestros años de experiencia aportando financiación privada a multitud
                                    de proyectos nos avala. Ahora acercamos la inversión privada al sector cultural y
                                    creativo.</p>
                            </div>
                            <div class="swiper-slide">
                                <div class="mat-icon-container">
                                    <span class="mat-icon-size-30 material-symbols-outlined">psychology</span>
                                </div>
                                <div class="border-bottom-2 border-secondary-creative-500 border-ventaja mt-1 mb-3">
                                </div>
                                <p class="p1-semibold">ANÁLISIS RIGUROSO</p>
                                <p class="p2-regular">Nuestro equipo de analistas examina cada proyecto para asegurar que
                                    cumpla con la calidad técnica y artística, además de los requisitos de solvencia,
                                    liquidez y riesgos exigidos.</p>
                            </div>
                            <div class="swiper-slide">
                                <div class="mat-icon-container">
                                    <span class="mat-icon-size-30 material-symbols-outlined">account_tree</span>
                                </div>
                                <div class="border-bottom-2 border-secondary-creative-500 border-ventaja mt-1 mb-3">
                                </div>
                                <p class="p1-semibold">DIVERSIFICACIÓN</p>
                                <p class="p2-regular">Variedad de proyectos entre los que el inversor puede distribuir su
                                    capital, obteniendo así diversas rentabilidades y plazos de devolución.</p>
                            </div>
                            <div class="swiper-slide">
                                <div class="mat-icon-container">
                                    <span class="mat-icon-size-30 material-symbols-outlined">swipe</span>
                                </div>
                                <div class="border-bottom-2 border-secondary-creative-500 border-ventaja mt-1 mb-3">
                                </div>
                                <p class="p1-semibold">SEGUIMIENTO</p>
                                <p class="p2-regular">Durante todo el proceso, tanto el promotor del proyecto como el inversor
                                    recibirán seguimiento del proyecto y contarán con un equipo de atención para
                                    resolver dudas.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="pagination" class="mt-4 d-xl-none">
                    <div class="swiper-pagination swiper-pagination-ventajas-creative position-relative"></div>
                </div>

                <div class="col-12 text-center mt-0 mt-xl-5">
                    <div class="call-to-action pt-2">
                        <a routerLink="/creative/registro" class="btn btn-secondary btn-financiacion btn-listo-empezar"
                            title="¿Listo para empezar?">¿Listo para empezar?</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-primary-900 primary-50 py-5">
        <div class="container">
            <div class="row justify-content-center pb-4">
                <div class="col-12 col-lg-3">
                    <h2 class="h2-semibold mb-2">RESOLVEMOS <br class="d-none d-lg-block">TUS DUDAS</h2>
                </div>
                <div class="col-12 col-lg-7">
                    <app-bloque-faqs [faqs]="faqs" [style]="'dark'"></app-bloque-faqs>
                </div>
            </div>
            <div class="row justify-content-center my-4">
                <div class="col-md-10 px-lg-0">
                    <div class="card-detalles">
                        <div class="row gx-0 px-lg-3">
                            <div class="col-lg-6 h-contacto">
                                <div class="contacto-background border-detalles-image h-100"></div>
                            </div>
                            <div class="col-lg-6 h-contacto">
                                <div
                                    class="bg-primary-50 primary-900 border-detalles-content p-4 h-100 d-flex align-items-center">
                                    <div class="detalles-contacto pe-lg-5">
                                        <h3 class="h3-semibold mb-2">¿Quieres conocer más detalles?</h3>
                                        <p class="p1-regular mb-4">Nuestro equipo se pondrá en contacto contigo con la mayor brevedad.</p>
                                        <div class="call-to-action">
                                            <a href="mailto:creative@segofinance.com" target="_blank"
                                                class="btn btn-secondary btn-contactar border-2 w-100 w-lg-auto"
                                                title="Contactar">Contactar</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>